import * as ko from 'knockout';

import { I18nText } from '../i18n_text';
import { MarketSegmentData } from '../api/market_segments';

export class MarketSegment {
  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });

  constructor(data?: MarketSegmentData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
    }
  }

  toData(): MarketSegmentData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
    };
  }
}
